module.exports = __webpack_public_path__ + "static/media/google.4ac5cf41.svg";